<template>
  <div>
    <div class="loading" v-if="loading">
      <i class="fas fa-ghost"></i> {{ message || 'Loading' }}&hellip;
    </div>
    <slot v-if="!loading"></slot>
  </div>
</template>

<script>
export default {
  props: ['loading', 'message']
}
</script>

<style scoped>
.loading {
  color: #77009b;
}
</style>
